<template>
  <div>
    <locationnodes
      :locationnodes="locationNodes"
      :totalitems="locationNodesLength"
      :isloading="isLoading"
      @locationNodeSaved="initialize()"
      @locationNodeAdded="setLocationLength()"
      @searchInitiated="setLocationLength()"
    ></locationnodes>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import locationNodes from "@/components/LocationsNode.vue";

export default {
  components: {
    locationnodes: locationNodes
  },
  watch: {
    
  },
  data() {
    return {
      isLoading: true,
      locationNodesLength: [],
      locationNodes: [],
      page:"",
      limit:""
    };
  },
  computed: {},
  async created() {
        this.initialize();
  },

  methods: {
    fetchLocationNodes() {
        this.isLoading=true
      Api()
        .get("/locationNodes/active")
        .then(response => {
          this.locationNodes = response.data;
                this.isLoading=false
        });
    },
   initialize() {
     this.fetchLocationNodes();
    },
  }
};
</script>
